import { Mail, Phone, MapPin } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import Logo from "./Logo";

const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="border-t border-slate-200/80 bg-slate-50/70 pt-16 pb-8 backdrop-blur-xl dark:border-slate-800/80 dark:bg-slate-950/60">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div>
            <h3 className="mb-4 text-lg font-semibold text-slate-900 dark:text-white">Inbloqs</h3>
            <ul className="space-y-2 text-sm text-slate-600 dark:text-slate-400">
              <li><a href="#about" className="hover:text-blue-600 dark:hover:text-blue-400">{t("about_us")}</a></li>
              <li><a href="#contact" className="hover:text-blue-600 dark:hover:text-blue-400">{t("contact")}</a></li>
            </ul>
          </div>

          <div>
            <h3 className="mb-4 text-lg font-semibold text-slate-900 dark:text-white">{t("solutions")}</h3>
            <ul className="space-y-2 text-sm text-slate-600 dark:text-slate-400">
              <li><a href="#solutions" className="hover:text-blue-600 dark:hover:text-blue-400">{t("on_premise_ai")}</a></li>
              <li><a href="#solutions" className="hover:text-blue-600 dark:hover:text-blue-400">{t("enterprise_automation")}</a></li>
              <li><a href="#solutions" className="hover:text-blue-600 dark:hover:text-blue-400">{t("capacitaciones")}</a></li>
              <li><a href="#solutions" className="hover:text-blue-600 dark:hover:text-blue-400">{t("it_infrastructure")}</a></li>
            </ul>
          </div>

          <div>
            <h3 className="mb-4 text-lg font-semibold text-slate-900 dark:text-white">{t("resources")}</h3>
            <ul className="space-y-2 text-sm text-slate-600 dark:text-slate-400">
              <li><a href="#blog" className="hover:text-blue-600 dark:hover:text-blue-400">{t("blog")}</a></li>
              <li><a href="#" className="hover:text-blue-600 dark:hover:text-blue-400">{t("whitepapers")}</a></li>
              <li><a href="#case-studies" className="hover:text-blue-600 dark:hover:text-blue-400">{t("case_studies")}</a></li>
              <li><a href="#" className="hover:text-blue-600 dark:hover:text-blue-400">{t("documentation")}</a></li>
            </ul>
          </div>

          <div>
            <h3 className="mb-4 text-lg font-semibold text-slate-900 dark:text-white">{t("contact_info")}</h3>
            <ul className="space-y-3 text-sm text-slate-600 dark:text-slate-400">
              <li className="flex items-center">
                <Mail className="mr-2 h-4 w-4 text-blue-600 dark:text-blue-400" />
                <a href="mailto:info@inbloqs.com" className="hover:text-blue-600 dark:hover:text-blue-400">
                  info@inbloqs.com
                </a>
              </li>
              <li className="flex items-center">
                <Phone className="mr-2 h-4 w-4 text-blue-600 dark:text-blue-400" />
                <a href="tel:+523313195542" className="hover:text-blue-600 dark:hover:text-blue-400">
                  +52 331 319 5542
                </a>
              </li>
              <li className="flex items-center">
                <MapPin className="mr-2 h-4 w-4 text-blue-600 dark:text-blue-400" />
                Guadalajara, México
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-4 border-t border-slate-200 pt-8 dark:border-slate-800 md:flex-row md:gap-0">
          <div className="mb-2 flex items-center md:mb-0">
            <Logo size="footer" />
          </div>

          <div className="text-sm text-slate-600 dark:text-slate-400">
            &copy; {currentYear} Inbloqs. {t("rights_reserved")}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
